import { useState, useEffect } from "react";
import { ApolloError, useQuery } from "@apollo/client";
import { getModuleLicenses } from "../../api/queries/moduleLicensesAPI";
import { IModuleLicensesEntity, IModuleLicense } from "./ModuleLicensesInterfaces";

export const ModuleLicensesEntity: IModuleLicensesEntity = {
    GetModuleLicenses: () => {
        const { loading, error, data } = useQuery(getModuleLicenses);
        const [moduleLicenses, setModuleLicenses] = useState<IModuleLicense[]>([]);
        const [apolloQueryError, setApolloQueryError] = useState<ApolloError | undefined>(undefined);

        useEffect(() => {
            if (data) {
                const moduleLicensesArray: IModuleLicense[] = data.module_license;
                setModuleLicenses(moduleLicensesArray);
            }
            if (error) {
                setApolloQueryError(error);
            }
        }, [data, error]);

        return { loading, moduleLicenses, apolloQueryError };
    },
};
